import React, { useEffect, useState } from 'react'
import style from "./Accusation.module.css";

import { bodyFetch } from "../../api/api";
import { useTitle } from "../../App";
import { consultInitData } from "./data";

import Header from '../../components/Header';
import Title from '../../components/Title';
import FileInput from "../../components/FileInput";
import Evidence from "../../components/accusationCase/Evidence";
import Investigation from "../../components/accusationCase/Investigation";
import Evidence_owner from "../../components/accusationCase/Evidence_owner";
import Personal from "../../components/accusationCase/Personal";

function Accusation() {
  useTitle("고소사건 경위확인")

  const sendApiUrl = process.env.REACT_APP_SEND_API_URL
  const [tab, setTab] = useState("one")
  const [showFiles, setShowFiles] = useState([]);
  const [checkedList, setCheckedList] = useState([]);


  // 복사 삭제 가능한 컴포넌트
  // init = localStorage 값 있으면 받아오기
  const checkLocalStorage = (key_name) => {
    let value

  if (key_name === "documentary") {
        value = [{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }]
    }else if (key_name === "exhibit") {
        value = [{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }]
    }else if (key_name === "personal") {
      value = [{ "date" : "", "agency" : "", "add" : "", "job" : "", "tel" : "", "cont" : "" }]
  }
    return JSON.parse(localStorage.getItem(key_name)) || value;
  }


  const [documentary ,setDocumentary] = useState(checkLocalStorage("documentary"));
    const [exhibit ,setExhibit] = useState(checkLocalStorage("exhibit"));
    const [personal ,setPersonal] = useState(checkLocalStorage("personal"));
  // 설문 응답 결과 state
  const [consult, setConsult] = useState(consultInitData)

  useEffect(()=>{
    setConsultWithArray()
  },[])



  //제출 후 초기화
  const resetConsult = () => {
    const newConsult = [ ...consult ]
    const newDocumentary= [...documentary]
    for (let i = 0; i < newConsult.length; i++) {
 if (["evidence_file","documentary_file","exhibit_file"].includes(newConsult[i].key)) {
        newConsult[i].answer = [""]
      }else if (newConsult[i].key === "documentary") {
          newConsult[i].answer = [{ "date" : "",  "agency" : "",  "content" : "", "evidence" : "" }]
      }else if (newConsult[i].key === "exhibit") {
          newConsult[i].answer = [{ "date" : "",  "agency" : "",  "content" : "", "evidence" : "" }]
      }else if (newConsult[i].key === "personal") {
     newConsult[i].answer = [{ "date" : "",  "agency" : "",  "add" : "", "tel" : "" , "cont" : ""}]
 }
      else {
        newConsult[i].answer = ""
      }
    }

    setConsult(newConsult)


      setDocumentary([{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }])
      setExhibit([{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }])
      setPersonal([{ "date" : "", "agency" : "", "add" : "", "job" : "", "tel" : "" , "cont" : ""  }])
    setShowFiles([])
  }

  const setConsultWithArray = () => {
    const newConsult = [ ...consult ]

    for (let i = 0; i < newConsult.length; i++) {
      if (localStorage.getItem(newConsult[i].key) !== null) {
        newConsult[i].answer = JSON.parse(localStorage.getItem(newConsult[i].key))
      }
    }
    setConsult(newConsult)
  }

  const beforeStep = () => {
    // if(!consultCheck(tab)){
    //   return false;
    // }

    const newConsult = [ ...consult ];

    if (tab === "three"){
      setTab("investigation")
    } else if (tab === "investigation"){
      setTab("exhibit")
    }  else if(tab==="accuse"){
        setTab("one")
    }else if(tab==="personal"){
        setTab("accuse")
    }
    else if(tab==="documentary"){
        setTab("personal")
    }else if(tab==="exhibit"){
        setTab("documentary")
    }
    else {
      setTab("")
    }
    setConsult(newConsult);
  };

  const nextStep = () => {
    if(!consultCheck(tab)){
      return false;
    }

    if(tab === "one"){
      setTab("accuse")
    } else if (tab==="accuse"){
        setTab("personal")
    }else if (tab==="personal"){
        setTab("documentary")
    }else if (tab === "documentary"){
        setTab("exhibit")
    } else if (tab === "exhibit"){
        setTab("investigation")
     }else if (tab === "investigation"){
        setTab("documentary")
    }
    else {
      setTab("")
    }
  };

  //반드시 입력해주세요, 숫자만 입력해주세요
  const consultCheck = () => {
    if ((consult.filter((e) => e.key === "info_name")[0].answer.length === 0) && tab === "one") {
      alert("의뢰인의 성함을 입력하세요.");
      return false;
    } else if ((consult.filter((e) => e.key === "info_tel")[0].answer.length === 0) && tab === "one") {
      alert("의뢰인의 연락처를 입력하세요.");
      return false;
    }
    // else if ((consult.filter((e) => e.key === "info_case")[0].answer.length === 0) && tab === "one") {
    //   alert("사건명을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "detail_occurred")[0].answer.length === 0) && tab === "one") {
    //   alert("사건 발생 경위를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "current_situation")[0].answer.length === 0) && tab === "three") {
    //   alert("현재 상황 및 변호인에 대한 요청 사항을 입력하세요.");
    //   return false;
    // }
    return true;
  };

  const consultCheck2 = () => {
    if(!consultCheck()){
      return false;
    }

    // return setConsultResult(true);
    // consult에 설명 붙인 값으로 전달하기

    const submitConsult = [ ...consult ]
    const findIndex = (key) => consult.findIndex(data => data.key === key)


      for (let i = 0; i < submitConsult[findIndex("documentary")].answer.length; i++){
          let newAnswer = { date : "", agency : "", content : "", evidence : "" };
          newAnswer.date = `증거(자료명): ${submitConsult[findIndex("documentary")].answer[i].date}`
          newAnswer.agency = `작성자: ${submitConsult[findIndex("documentary")].answer[i].agency}`
          newAnswer.content = `제출 유무: ${submitConsult[findIndex("documentary")].answer[i].content}`
          newAnswer.evidence = ` 내용(사건 관련성, 취득 경위): ${submitConsult[findIndex("documentary")].answer[i].evidence}`
          submitConsult[findIndex("documentary")].answer[i] = newAnswer
      }
      for (let i = 0; i < submitConsult[findIndex("exhibit")].answer.length; i++){
          let newAnswer = { date : "", agency : "", content : "", evidence : "" };
          newAnswer.date = `증거(자료명): ${submitConsult[findIndex("exhibit")].answer[i].date}`
          newAnswer.agency = `소유자: ${submitConsult[findIndex("exhibit")].answer[i].agency}`
          newAnswer.content = `제출유무: ${submitConsult[findIndex("exhibit")].answer[i].content}`
          newAnswer.evidence = ` 내용(사건 관련성, 취득 경위): ${submitConsult[findIndex("exhibit")].answer[i].evidence}`
          submitConsult[findIndex("exhibit")].answer[i] = newAnswer
      }
      for (let i = 0; i < submitConsult[findIndex("personal")].answer.length; i++){
          let newAnswer = { date : "", agency : "", add : "", job : "" , tel : "", cont : ""};
          newAnswer.date = `성명 ${submitConsult[findIndex("personal")].answer[i].date}`
          newAnswer.agency = `주민등록번호: ${submitConsult[findIndex("personal")].answer[i].agency}`
          newAnswer.add = `주소: ${submitConsult[findIndex("personal")].answer[i].add}`
          newAnswer.job = `직업: ${submitConsult[findIndex("personal")].answer[i].job}`
          newAnswer.tel = `전화: ${submitConsult[findIndex("personal")].answer[i].tel}`
          newAnswer.cont = `입증하려는 내용: ${submitConsult[findIndex("personal")].answer[i].cont}`
          submitConsult[findIndex("personal")].answer[i] = newAnswer
      }
    const newFileAnswer = (key_name) => {
      for (let i = 0; i < submitConsult[findIndex(key_name)].answer.length; i++){
        let newAnswer = { name : "", url : "" };
        newAnswer.name = `증거자료 파일명: ${submitConsult[findIndex(key_name)].answer[i].name}`
        newAnswer.url = `증거자료 파일 링크: <a href="${submitConsult[findIndex(key_name)].answer[i].url}" target="_blank">다운로드</a>`
        submitConsult[findIndex(key_name)].answer[i] = newAnswer
      }
      return submitConsult[findIndex(key_name)].answer
    }

      newFileAnswer("documentary_file")
      newFileAnswer("exhibit_file")

    if(window.confirm("제출하시겠습니까?")){

      bodyFetch(sendApiUrl, {
          statement: submitConsult,
          litigation_name: "형사 고소사건 경위확인",
          customer_name: submitConsult[findIndex("info_name")].answer,
          case_name: submitConsult[findIndex("info_case")].answer,
          tel: submitConsult[findIndex("info_tel")].answer }, (obj) => {
        if(obj.result) {
          console.log("SUCCESS :: 진술서가 제출되었습니다.")
        } else {
          alert("전송 실패. 다시 시도해주세요")
        }
      }, "POST");

      alert("제출되었습니다.")
      localStorage.clear()
      setTab("one")
      resetConsult()

    } else {
      alert("제출이 취소되었습니다.")
    }

  };

  const handleInput = (e) => {
    const newConsult = [ ...consult ]


    const newDocumentary = [...documentary]
    const newExhibit = [...exhibit]
    const newPersonal = [...personal]

    if(e.currentTarget.name === "info_name") {
      newConsult.filter((e) => e.key === "info_name")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_tel") {
      newConsult.filter((e) => e.key === "info_tel")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "delator_name") {
      newConsult.filter((e) => e.key === "delator_name")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "info_case") {
        newConsult.filter((e) => e.key === "info_case")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "delator_ssn") {
        newConsult.filter((e) => e.key === "delator_ssn")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "delator_address") {
        newConsult.filter((e) => e.key === "delator_address")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "delator_number") {
        newConsult.filter((e) => e.key === "delator_number")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "delator_email") {
        newConsult.filter((e) => e.key === "delator_email")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "delator_agent") {
        newConsult.filter((e) => e.key === "delator_agent")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "respondent_name") {
        newConsult.filter((e) => e.key === "respondent_name")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "respondent_ssn") {
        newConsult.filter((e) => e.key === "respondent_ssn")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "respondent_address") {
        newConsult.filter((e) => e.key === "respondent_address")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "respondent_tell") {
        newConsult.filter((e) => e.key === "respondent_tell")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "respondent_info") {
        newConsult.filter((e) => e.key === "respondent_info")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "respondent_ssn") {
        newConsult.filter((e) => e.key === "respondent_ssn")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "drift") {
        newConsult.filter((e) => e.key === "drift")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "actually") {
        newConsult.filter((e) => e.key === "actually")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "details") {
        newConsult.filter((e) => e.key === "details")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "criminal") {
        newConsult.filter((e) => e.key === "criminal")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "punishment") {
        newConsult.filter((e) => e.key === "punishment")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "enquiry") {
        newConsult.filter((e) => e.key === "enquiry")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "incident_detail") {
        newConsult.filter((e) => e.key === "incident_detail")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "incident_detail_1") {
        newConsult.filter((e) => e.key === "incident_detail_1")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "incident_detail_2") {
        newConsult.filter((e) => e.key === "incident_detail_2")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "incident_detail_3") {
        newConsult.filter((e) => e.key === "incident_detail_3")[0].answer = e.currentTarget.value;
    }  else if(e.currentTarget.name === "evidence_name") {
        newConsult.filter((e) => e.key === "evidence_name")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "evidence_tel") {
        newConsult.filter((e) => e.key === "evidence_tel")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "evidence_address") {
        newConsult.filter((e) => e.key === "evidence_address")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "evidence_job") {
        newConsult.filter((e) => e.key === "evidence_job")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "evidence_tel") {
        newConsult.filter((e) => e.key === "evidence_tel")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "evidence_contents") {
        newConsult.filter((e) => e.key === "evidence_contents")[0].answer = e.currentTarget.value;
    }else if(e.currentTarget.name === "evidence_num") {
        newConsult.filter((e) => e.key === "evidence_num")[0].answer = e.currentTarget.value;
    }



    else if(e.currentTarget.name === "documentary_file") {
        newConsult.filter((e) => e.key === "documentary_file")[0].answer = showFiles
    }else if(e.currentTarget.name === "exhibit_file") {
        newConsult.filter((e) => e.key === "exhibit_file")[0].answer = showFiles
    }

    else if(e.currentTarget.name === "current_situation") {
      newConsult.filter((e) => e.key === "current_situation")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "etc") {
      newConsult.filter((e) => e.key === "etc")[0].answer = e.currentTarget.value;


    }  else if(e.currentTarget.name === "documentary_name") {
        newConsult.filter((e) => e.key === "documentary")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.name = e.currentTarget.value

            }
            return item;
        })

        newDocumentary.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.date = e.currentTarget.value
            }
            return item;
        })

    } else if(e.currentTarget.name === "documentary_agency") {
        newConsult.filter((e) => e.key === "documentary")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.agency = e.currentTarget.value
            }
            return item;
        })

        newDocumentary.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.agency = e.currentTarget.value
            }
            return item;
        })

    }

    else if(e.currentTarget.name === `documentary_submit_${e.currentTarget.dataset.index}`) {

        newConsult.filter((e) => e.key === "documentary")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){

            if(e.currentTarget.checked){
                item.content = e.currentTarget.value
            }}
            return item;
        })

        newDocumentary.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                    item.content =  e.currentTarget.value

            }
            return item;
        })

    }

    else if(e.currentTarget.name === "documentary_evidence") {
        newConsult.filter((e) => e.key === "documentary")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.evidence = e.currentTarget.value
            }
            return item;
        })

        newDocumentary.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.evidence = e.currentTarget.value
            }
            return item;
        })

    }else if(e.currentTarget.name === "documentary_date") {
        newConsult.filter((e) => e.key === "documentary")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.date = e.currentTarget.value
            }
            return item;
        })

        newDocumentary.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.date = e.currentTarget.value
            }
            return item;
        })

    }


    else if(e.currentTarget.name === "exhibit_date") {
        newConsult.filter((e) => e.key === "exhibit")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.date = e.currentTarget.value
            }
            return item;
        })

        newExhibit.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.date = e.currentTarget.value
            }
            return item;
        })

    } else if(e.currentTarget.name === "exhibit_agency") {
        newConsult.filter((e) => e.key === "exhibit")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.agency = e.currentTarget.value
            }
            return item;
        })

        newExhibit.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.agency = e.currentTarget.value
            }
            return item;
        })

    }
    else if(e.currentTarget.name === `exhibit_submit_${e.currentTarget.dataset.index}`) {

        newConsult.filter((e) => e.key === "exhibit")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){

                if(e.currentTarget.checked){
                    item.content = e.currentTarget.value
                }}
            return item;
        })

        newExhibit.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.content =  e.currentTarget.value

            }
            return item;
        })

    }
    else if(e.currentTarget.name === "exhibit_evidence") {
        newConsult.filter((e) => e.key === "exhibit")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.evidence = e.currentTarget.value
            }
            return item;
        })

        newExhibit.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.evidence = e.currentTarget.value
            }
            return item;
        })

    }

    else if(e.currentTarget.name === "personal_date") {
        newConsult.filter((e) => e.key === "personal")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.date = e.currentTarget.value
            }
            return item;
        })

        newPersonal.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.date = e.currentTarget.value
            }
            return item;
        })

    } else if(e.currentTarget.name === "personal_agency") {
        newConsult.filter((e) => e.key === "personal")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.agency = e.currentTarget.value
            }
            return item;
        })

        newPersonal.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.agency = e.currentTarget.value
            }
            return item;
        })

    }
    else if(e.currentTarget.name === "personal_add") {
        newConsult.filter((e) => e.key === "personal")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.add = e.currentTarget.value
            }
            return item;
        })

        newPersonal.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.add = e.currentTarget.value
            }
            return item;
        })

    }
    else if(e.currentTarget.name === "personal_job") {
        newConsult.filter((e) => e.key === "personal")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.job = e.currentTarget.value
            }
            return item;
        })

        newPersonal.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.job = e.currentTarget.value
            }
            return item;
        })

    }
    else if(e.currentTarget.name === "personal_job") {
        newConsult.filter((e) => e.key === "personal")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.job = e.currentTarget.value
            }
            return item;
        })

        newPersonal.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.job = e.currentTarget.value
            }
            return item;
        })

    }
    else if(e.currentTarget.name === "personal_tel") {
        newConsult.filter((e) => e.key === "personal")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.tel = e.currentTarget.value
            }
            return item;
        })

        newPersonal.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.tel = e.currentTarget.value
            }
            return item;
        })

    }
    else if(e.currentTarget.name === "personal_cont") {
        newConsult.filter((e) => e.key === "personal")[0].answer.map((item, index) => {
            if(Number(e.currentTarget.dataset.index) === index){
                item.cont = e.currentTarget.value
            }
            return item;
        })

        newPersonal.map((item, index)=> {
            if(Number(e.currentTarget.dataset.index) === index){
                item.cont = e.currentTarget.value
            }
            return item;
        })

    }
    postLocalStorage()
    setConsult(newConsult)

      setDocumentary(newDocumentary)
      setExhibit(newExhibit)
      setPersonal(newPersonal)
  }



  // 아이템 추가
  const handleAddItem = (key) => {
    const newConsult = [ ...consult ]
    const findIndex = consult.findIndex(data => data.key === key)

    switch(key) {


        case "documentary" :
            newConsult[findIndex].answer = [{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }, ...newConsult[findIndex].answer]
            setDocumentary([{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }, ...documentary])
            break;
        case "exhibit" :
            newConsult[findIndex].answer = [{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }, ...newConsult[findIndex].answer]
            setExhibit([{ "date" : "", "agency" : "", "content" : "", "evidence" : "" }, ...exhibit])
            break;
        case "personal" :
            newConsult[findIndex].answer = [{ "date" : "", "agency" : "", "add" : "", "job" : "", "tel" : "" , "cont" : ""  }, ...newConsult[findIndex].answer]
            setPersonal([{ "date" : "", "agency" : "", "add" : "", "job" : "" , "tel" : "", "cont" : ""}, ...personal])
            break;
      default :

    }
    setConsult(newConsult)
  }

  const handleDeleteItem = (key) => {
    const newConsult = [ ...consult ]
    const findIndex = consult.findIndex(data => data.key === key)

    switch(key) {

        case "documentary" :
            newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
            setDocumentary(documentary.slice(1))
            break;

        case "exhibit" :
            newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
            setExhibit(exhibit.slice(1))
            break;
        case "personal" :
            newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
            setPersonal(personal.slice(1))
            break;

      default :

    }
    setConsult(newConsult)
  }


    // localStorage를 state로 바로 꺼내쓰기 어려움
    useEffect(()=> {
      const newConsult = [ ...consult ]
        newConsult.filter((e) => e.key === "documentary_file")[0].answer = showFiles.filter(data => data.key === "documentary")
        newConsult.filter((e) => e.key === "exhibit_file")[0].answer = showFiles.filter(data => data.key === "exhibit")

    },[consult])

  const getLocalStorage = (key_name) => JSON.parse(localStorage.getItem(key_name))

  const getShowFiles = (data) => {
    setShowFiles(data)
  }

  const postLocalStorage = () => {
    for (let i = 0; i < consult.length; i++) {
      const inputValue = JSON.stringify(consult[i].answer)
      localStorage.setItem(consult[i].key, inputValue);
    }

    // localStorage.setItem("investigation", JSON.stringify(investigation))
  }

  return (
    <>
      <Header />
      <Title title={"형사 고소사건 경위확인"} />

      { tab === "one" ? (

        <>
          <section>

            <p className={style.main_tit}>1. 기초사항</p>

            <div className={style.item_input_text}>
              <p className={style.tit}>성함</p>
              <input type="text" name="info_name" placeholder='예) 홍길동' value={consult.filter((e)=>e.key === "info_name")[0].answer} onChange={handleInput} />
            </div>

            <div className={style.item_input_text}>
              <p className={style.tit}>연락처</p>
              <input type="text" name="info_tel" placeholder='예) 01012345678' value={consult.filter((e)=>e.key === "info_tel")[0].answer} onChange={handleInput} />
            </div>

            <div className={style.item_input_text}>
              <p className={style.tit}>사건명</p>
              <input type="text" name="info_case" placeholder='대출사기' value={consult.filter((e)=>e.key === "info_case")[0].answer} onChange={handleInput} />
            </div>

          </section>
            <section>
                <p className={style.main_tit}>2. 고소인</p>
                {/* <p className={style.h2}></p> */}
                <div className={style.item_input_text}>
                    <p className={style.tit}>성명 (법인인 경우: 상호, 대표자) </p>
                    - 고소인이 법인인 경우 법인등기부 등본이 첨부되어야 하므로 법인등기부등본을 함께 보내주시기 바랍니다.
                    <input type="text" name="delator_name" placeholder='예) 홍길동' value={consult.filter((e)=>e.key === "delator_name")[0].answer} onChange={handleInput} />
                </div>

                <div className={style.item_input_text}>
                    <p className={style.tit}>주민등록번호 (법인인 경우: 법인등록번호)</p>
                    <input type="text" name="delator_ssn" placeholder='예) 01012345678' value={consult.filter((e)=>e.key === "delator_ssn")[0].answer} onChange={handleInput} />
                </div>

                <div className={style.item_input_text}>
                    <p className={style.tit}>주소 (현거주지, 법인인 경우 주사무소 소재지)</p>
                    <input type="text" name="delator_address" placeholder='' value={consult.filter((e)=>e.key === "delator_address")[0].answer} onChange={handleInput} />
                </div>
                <div className={style.item_input_text}>
                    <p className={style.tit}>전화번호 (휴대폰, 자택 또는 사무실)</p>
                    <input type="text" name="delator_number" placeholder='예) 01012341234' value={consult.filter((e)=>e.key === "delator_number")[0].answer} onChange={handleInput} />
                </div>
                <div className={style.item_input_text}>
                    <p className={style.tit}>이메일주소</p>
                    <input type="text" name="delator_email" placeholder='daeryun@naver.com' value={consult.filter((e)=>e.key === "delator_email")[0].answer} onChange={handleInput} />
                </div>
                <div className={style.item_input_text}>
                    <p className={style.tit}>미성년자의 친권자 등 법정대리인이 고소하는 경우</p>
                    - 미성년자와의 관계를 알 수 있는 자료(가족관계증명서 등 자료를 함께 보내주시기 바랍니다)
                    <input type="text" name="delator_agent" placeholder='' value={consult.filter((e)=>e.key === "delator_agent")[0].answer} onChange={handleInput} />
                </div>
            </section>

            <section>
                <p className={style.main_tit}>3. 피고소인</p>
                {/* <p className={style.h2}></p> */}
                <div className={style.item_input_text}>
                    <p className={style.tit}>성명 (법인인 경우: 상호, 대표자) </p>
                    ① 이름을 알지 못하는 경우 불상자라고 기재하여 주시기 바랍니다. <br/>
                    ② 상대방이 가명을 사용하였더라도 알고있는대로 기재하여 주시기 바랍니다. <br/>
                    ③ 피고소인의 신분을 알 수 있는 자료 (명함 등)이 있는 경우 함께 보내주시기 바랍니다. <br/>
                    ④ 피고소인이 법인인 경우 법인등기부 등본이 첨부되어야 하므로 법인등기부등본을 함께 보내주시기 바랍니다.

                    <input type="text" name="respondent_name" placeholder='예) 홍길동' value={consult.filter((e)=>e.key === "respondent_name")[0].answer} onChange={handleInput} />
                </div>

                <div className={style.item_input_text}>
                    <p className={style.tit}>주민등록번호 (법인인 경우: 법인등록번호)</p>
                    - 주민등록번호를 알지 못하는 경우 불상으로 기재하여 주시기 바랍니다.
                    <input type="text" name="respondent_ssn" placeholder='' value={consult.filter((e)=>e.key === "respondent_ssn")[0].answer} onChange={handleInput} />
                </div>

                <div className={style.item_input_text}>
                    <p className={style.tit}>주소 (현거주지, 법인인 경우 주사무소 소재지)</p>
                    ① 알고있는 상대방의 주소지를 기재하여 주시기 바랍니다.<br/>
                    ② 상대방의 집주소는 모르고 사무실 주소는 아는 경우 사무실 주소를 기재하여 주시기 바랍니다.<br/>
                    <input type="text" name="respondent_address" placeholder='' value={consult.filter((e)=>e.key === "respondent_address")[0].answer} onChange={handleInput} />
                </div>
                <div className={style.item_input_text}>
                    <p className={style.tit}>전화번호 (휴대폰, 자택 또는 사무실)</p>
                    <input type="text" name="respondent_tell" placeholder='01012341234' value={consult.filter((e)=>e.key === "respondent_tell")[0].answer} onChange={handleInput} />
                </div>
                <div className={style.item_input_text}>
                    <p className={style.tit}>인적사항을 제대로 알지 못하고 있는 경우</p>
                    - 피고소인의 성별, 특징적인 외모, 인상착의, 피고소인을 알고 있는 사람 등 피고소인의 인적사항에 대하여 알고 있는 사실을 구체적으로 기재하여 주시기 바랍니다
                    <input type="text" name="respondent_info" placeholder='' value={consult.filter((e)=>e.key === "respondent_info")[0].answer} onChange={handleInput} />
                </div>
            </section>

        </>

      ) :null}

        { tab === "accuse" ? (
            <>

                <section>

                    <p className={style.main_tit}>4. 고소취지</p>
                    <p className={style.tit_desc}>상대방이 어떤 죄명으로 범죄를 저질렀다고 생각하고 계신지 기재하여 주시기 바랍니다(변호사의 법률검토에 따라 다른 법조가 적용될 수 있습니다).</p>

                    <div className={style.item_input_textarea}>
                        <textarea name="drift" value={consult.filter((e)=>e.key === "drift")[0].answer} onChange={handleInput} />
                    </div>

                </section>
                <section>
                    <p className={style.main_tit}>5. 고소사실</p>
                    <p className={style.sub_title}>
                        ■ 당사자간 관계 (고소인과 피고소인 사이의 관계)
                    </p>
                    <p className={style.tit_desc}>
                        ① 친족관계에 있다면 가족관계증명서를 첨부하여 주시기 바랍니다. <br/>
                        ② 아무런 친족관계가 없다면 아무런 친족관계가 없습니다라고 기재해주시고, 이어서 어떻게 피고소인을 알게 되었는지 간략히 기재하여 주시기 바랍니다.
                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="actually" value={consult.filter((e)=>e.key === "actually")[0].answer} onChange={handleInput} />
                    </div>
                    <p className={style.sub_title}>
                        ■ 고소에 이르게 된 경위
                    </p>
                    <p className={style.tit_desc}>
                        구체적 일시, 장소, 행위의 내용, 행위의 상대방을 육하원칙에 맞게 작성하여 주시기 바랍니다. <br/>
                        ① 처음 알게 된 경위,  <br/>
                        ② 피고소인이 어떠한 범행행위를 언제, 어떻게 하였는지(여러 건인 경우, 각 건별로 나누어서 작성하여 주시기 바랍니다), <br/>
                        ③ 왜 하였다고 생각하는지,  <br/>
                        ④ 그 이후 피고소인은 어떠한 행동을 취하였는지, <br/>
                        ⑤ 왜 고소를 하여야겠다고 생각했는지 구체적으로 작성하여 주시기 바랍니다.

                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="details" value={consult.filter((e)=>e.key === "details")[0].answer} onChange={handleInput} />
                    </div>
                    <p className={style.sub_title}>
                        ■ 피고소인의 범죄사실
                    </p>
                    <p className={style.tit_desc}>
                        위 [고소에 이르게 된 경위] 내용 중 피고소인이 어떠한 범행행위를 언제, 어떻게 하였는지 각 일시별로 구체적으로 기재해주시고,
                        이에 부합하는 증거는 무엇인지도 함께 기재하여 주시기 바랍니다(변호사가 구체적으로 내용 및 증거자료를 검토한 이후,
                        불필요한 부분, 필요한 부분을 정리하고, 부족한 증거관계가 있다면 추가적으로 요청드립니다 /
                        기재하여주신 내용에 따라 법률적 검토를 거쳐 가장 적합한 법조를 적용하고, 내용이 부족한 경우,
                        해당내용의 설명을 전체적으로 다시 요청드릴 수 있음을 미리 안내드립니다)

                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="criminal" value={consult.filter((e)=>e.key === "criminal")[0].answer} onChange={handleInput} />
                    </div>
                    <p className={style.sub_title}>
                        ■ 피해의 심각성 및 강력한 처벌 희망의사
                    </p>
                    <p className={style.tit_desc}>
                        이 사건으로 인해 얼마나 피해가 심각한지(심리상담소견서, 가족간불화, 이자연체로 인해 압류, 피해가 심각하여 매일 일기를 썼다는 등)
                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="punishment" value={consult.filter((e)=>e.key === "punishment")[0].answer} onChange={handleInput} />
                    </div>
                    <p className={style.sub_title}>
                        ■ 수사요망사항
                    </p>
                    <p className={style.tit_desc}>
                        ① cctv확보필요(확보가 필요한 곳의 주소, 보관자, 필요한 영상의 시간대) <br/>
                        ② 접근금지신청 원하시는지 (죄명에 따라 신청이 불가한 경우도 있습니다)<br/>
                        ③ 사건 관련된 내용을 잘 알고 있어 참고인으로 조사해주었으면 하는 사람이 있는지 등
                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="enquiry" value={consult.filter((e)=>e.key === "enquiry")[0].answer} onChange={handleInput} />
                    </div>
                </section>



            </>
        ) : null}



        {
            tab==="personal" ? (
                <section>
                    <p className={style.main_tit}>6. 인적증거 (목격자, 기타 참고인 등)</p>
                    <p className={style.tit_desc}>발생한 사건에 관하여, 증거 기타 소지하고 있는 관련 자료가 있다면 자료명, 내용(사건과의 관련성), 취득 경위를 기억나는 만큼만 기재하여 주시기 바랍니다.</p>

                    <div className={style.add_box_wrapper}>
                        <p className={style.h2}>의뢰인</p>
                        <div className={style.btn_box}>
                            <div className={style.btn} onClick={() => handleDeleteItem("personal")}>
                                <img src='images/btn_delete.webp' alt='삭제 버튼' />
                            </div>
                            <div className={style.btn}  onClick={() => handleAddItem("personal")}>
                                <img src='images/btn_plus.webp' alt='추가 버튼' />
                            </div>
                        </div>

                        {personal.map((item, index) => <Personal key={index} index={index} key_name={"personal"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}

                        {/*<FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />*/}
                    </div>

                </section>
            ) : null
        }



      { tab === "documentary" ? (
        <>
            {/*<section>*/}
            {/*    <p className={style.main_tit}>6. 인적증거 (목격자, 기타 참고인 등)</p>*/}

            {/*    <div className={style.item_input_text}>*/}
            {/*        <p className={style.tit}>성명</p>*/}
            {/*        <input type="text" name="evidence_name" placeholder='예) 홍길동' value={consult.filter((e)=>e.key === "evidence_name")[0].answer} onChange={handleInput} />*/}
            {/*    </div>*/}
            {/*    <div className={style.item_input_text}>*/}
            {/*        <p className={style.tit}>주민등록번호</p>*/}
            {/*        <input type="text" name="evidence_num" placeholder='예) 01012345678' value={consult.filter((e)=>e.key === "evidence_num")[0].answer} onChange={handleInput} />*/}
            {/*    </div>*/}
            {/*    <div className={style.item_input_text}>*/}
            {/*        <p className={style.tit}>주소</p>*/}
            {/*        <input type="text" name="evidence_address" placeholder='대출사기' value={consult.filter((e)=>e.key === "evidence_address")[0].answer} onChange={handleInput} />*/}
            {/*    </div>*/}
            {/*    <div className={style.item_input_text}>*/}
            {/*        <p className={style.tit}>직업</p>*/}
            {/*        <input type="text" name="evidence_job" placeholder='대출사기' value={consult.filter((e)=>e.key === "evidence_job")[0].answer} onChange={handleInput} />*/}
            {/*    </div>*/}
            {/*    <div className={style.item_input_text}>*/}
            {/*        <p className={style.tit}>전화</p>*/}
            {/*        <input type="text" name="evidence_tel" placeholder='대출사기' value={consult.filter((e)=>e.key === "evidence_tel")[0].answer} onChange={handleInput} />*/}
            {/*    </div>*/}
            {/*    <div className={style.item_input_text}>*/}
            {/*        <p className={style.tit}>입증하려는 내용</p>*/}
            {/*        <input type="text" name="evidence_contents" placeholder='대출사기' value={consult.filter((e)=>e.key === "evidence_contents")[0].answer} onChange={handleInput} />*/}
            {/*    </div>*/}
            {/*    ※ 참고인의 인적사항과 연락처를 정확히 알 수 없으면 참고인을 특정할 수 있도록 성별, 외모 등을 ‘입증하려는 내용’란에 아는 대로 기재하시기 바랍니다.*/}
            {/*</section>*/}
      <section>
          <p className={style.main_tit}>7. 증거서류 (진술서, 차용증, 각서, 금융거래내역서, 진단서 등)</p>

          <div className={style.add_box_wrapper}>
              <p className={style.h2}>의뢰인</p>
              <div className={style.btn_box}>
                  <div className={style.btn} onClick={() => handleDeleteItem("documentary")}>
                      <img src='images/btn_delete.webp' alt='삭제 버튼' />
                  </div>
                  <div className={style.btn} onClick={() => handleAddItem("documentary")}>
                      <img src='images/btn_plus.webp' alt='추가 버튼'  />
                  </div>
              </div>

              {documentary.map((item, index) => <Evidence_owner key={index} index={index} key_name={"documentary"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item} /> )}

              <FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />
          </div>

      </section>


      </>
      ) : null}
        {
            tab==="exhibit" ?
                (
<>
    <section>
        <p className={style.main_tit}>8. 증거물</p>

        <div className={style.add_box_wrapper}>
            <p className={style.h2}>의뢰인</p>
            <div className={style.btn_box}>
                <div className={style.btn} onClick={() => handleDeleteItem("exhibit")}>
                    <img src='images/btn_delete.webp' alt='삭제 버튼' />
                </div>
                <div className={style.btn}  onClick={() => handleAddItem("exhibit")}>
                    <img src='images/btn_plus.webp' alt='추가 버튼' />
                </div>
            </div>

            {exhibit.map((item, index) => <Evidence_owner key={index} index={index} key_name={"exhibit"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item} /> )}

            <FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />
        </div>

    </section>

    <section>
        <p className={style.main_tit}>9. 기타 증거</p>

        <div className={style.item_input_text}>
            <div className={style.item_input_textarea}>
                <textarea name="etc" placeholder='' value={consult.filter((e)=>e.key === "etc")[0].answer} onChange={handleInput}/>
            </div>
        </div>



    </section>

</>
                )
              :null
        }
        { tab === "investigation" ? (
            <>
                <section>
                    <p className={style.main_tit}>10. 관련사건의 수사 및 재판 여부*</p>
                    <p className={style.sub_title}>
                        ■ 이전에 같은 범죄사실로 다른 검찰청 또는 경찰서에 고소장 또는 신고를 한 사실이 있는지(중복 고소 여부, 재고소금지사유 해당여부)

                    </p>
                    <p className={style.tit_desc}>
                        ① 만약 있다면, 그 이후 어떻게 종결되었는지(합의, 고소취소, 혐의없음으로 불송치종결 등)
                        <br/>
                        ② 왜 다시 고소를 하게 되었는지
                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="incident_detail_1" value={consult.filter((e)=>e.key === "incident_detail_1")[0].answer} onChange={handleInput} />
                    </div>
                    <p className={style.sub_title}>
                        ■ 현재 이 사건과 관련된 사건으로 피고소인이 또는 공범이 검찰청이나 경찰서에서 수사계속중인지(관련 형사사건 수사계속 여부)
                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="incident_detail_2" value={consult.filter((e)=>e.key === "incident_detail_2")[0].answer} onChange={handleInput} />
                    </div>
                    <p className={style.sub_title}>
                        ■ 현재 이 사건과 관련된 사건으로 민사소송을 제기한 사실이 있는지
                    </p>
                    <p className={style.tit_desc}>

                    </p>
                    <div className={style.item_input_textarea}>
                        <textarea name="incident_detail_3" value={consult.filter((e)=>e.key === "incident_detail_3")[0].answer} onChange={handleInput} />
                    </div>
                    <div className={style.tit_wrapper}>
                        <div className={style.desc}>
                            <p className={style.sub}>맡겨주신 사건, 최선의 결과로 보답하겠습니다.</p>
                            <p className={style.title}>법무법인 대륜 <span>1800-7905</span></p>
                            <p className={style.email}>대표메일 law@daeryunlaw.com</p>
                        </div>
                    </div>
                </section>

            </>
        ) : null}

      {/* 하단 버튼 */}
      { (tab === "one") ? (
          <div className={style.btn_wrapper_1} onClick={nextStep}>
            <div className={style.start_btn}>다음</div>
          </div>
        ) : (tab === "investigation") ? (
          <div className={style.btn_wrapper_2}>
              <div className={style.before_btn} onClick={beforeStep}>이전</div>
              <div className={style.finish_btn} onClick={consultCheck2}>완료</div>
          </div>
        ): (
            <div className={style.btn_wrapper_2}>
              <div className={style.before_btn} onClick={beforeStep}>이전</div>
              <div className={style.start_btn} onClick={nextStep}>다음</div>
            </div>
      )}
    </>
  )
}

export default Accusation